<template>
  <WorkBenchSequenceWaggonWorkPackageAdd>
    <template #content>
      <StandardFlexBox
        width="calc(30% - 4px)"
        height="calc(100% - 8px)"
        class="t-rounded mt-1 mr-1 mb-1 pa-1"
        direction="column"
        >
        <AIIcon
        v-if="ai_animation_recommendation"
        style="margin-left: calc(50% - 100px); margin-top: 30px"
        width="200px"
        :animation="true"
        />
        <template v-else>
        <StandardFlexBox
          height="28px"
          >
          <AIIcon
          class="mr-1"
          style="margin-top: 2px"
          width="18px"
          @click.native="test()"
          />
          <div class="font-weight-light">
            Recommendations:
          </div>
        </StandardFlexBox>
        <StandardFlexBox
          height="calc(100% - 28px)"
          v-if="getWBObject({type: 'sworkpackagerecommendations',id: $route.params.waggon_id})"
          >
          <Workpackage
            class="ma-1 cursor-pointer"
            v-for="(workpackage, index) in getWBObject({type: 'sworkpackagerecommendations',id: $route.params.waggon_id}).workpackages"
            :key="index"
            :workpackage="workpackage"
            @click.native="$router.push({
              name: `${location}SequenceWaggonWorkPackageInfoBox`,
              params: {
                info_box_template_type: 'recommendation',
                workpackage_id: index
              }
            })"
            />
        </StandardFlexBox>
        </template>
      </StandardFlexBox>
      <transition
        name="dialog_slide"
        >
        <router-view
          v-if="$route.name.includes('WorkPackageEditor')"
          style="z-index: 20"
        />
      </transition>
      <StandardFlexBox
        v-if="$route.name.includes('WorkPackageInfoBoxInfo')"
        width="500px"
        height="calc(100% - 8px)"
        class="mt-1 mr-1 mb-1 pt-1 pl-1"
        overflow="hidden"
        no_wrap="true"
        >
        <StandardFlexBox
          v-if="$route.params.template_type !== 'recommendation'"
          class="cursor-pointer"
          height="100%"
          width="40px"
          direction="column"
          justify_content="center"
          align_content="center"
          style="border-left: solid 1px white"
          @click.native="$router.push({
              name: `${location}SequenceWaggonWorkPackageAdd`
            })"
          >
          <v-icon>keyboard_arrow_right</v-icon>
        </StandardFlexBox>
        <router-view style="z-index: 20"/>
        <StandardFlexBox
          v-if="$route.params.template_type === 'recommendation'"
          class="cursor-pointer"
          height="100%"
          width="40px"
          direction="column"
          justify_content="center"
          align_content="center"
          @click.native="$router.push({
              name: `${location}SequenceWaggonWorkPackageAdd`
            })"
          >
          <v-icon>keyboard_arrow_left</v-icon>
        </StandardFlexBox>
      </StandardFlexBox>
      <StandardFlexBox
        :width="$route.matched[5]?
          'calc(100% - 30% - 500px)':'70%'"
        height="calc(100% - 8px)"
        class="mt-1 mb-1 pa-1"
        :style="$route.matched[5] &&
          $route.params.template_type !== 'recommendation'?
          '':'border-left: solid 1px white'"
        direction="column"
        >
        <StandardFlexBox height="28px">
          <template v-if="workbench_variables.search === ''">
            <TText
              :value="$store.state.WorkBench.all_loaded.includes(`workpackages`) ? 'All' : 'Last Updated'"
            />
          </template>
          <template v-else>
            <TText
              :value="'Search result{symbol} {searchVal}'"
              :value_props="{symbol: ':', searchVal: workbench_variables.search}"
            />
          </template>
          <v-progress-circular v-if="$store.state.WorkBenchLocal.workbench_variables.loading" class="ml-2" :width="2" :size="20" indeterminate color="primary"></v-progress-circular>
          <v-spacer/>
            <TSearchField
            height="23px"
            width="20%"
            style="margin:auto"
            color="#757575"
            border_color="rgb(41,41,41)"
            placeholder="Search for workpackages"
              :value="workbench_variables.search"
            @input="workbenchSearch($event.target.value)"
            @cancel="updateWBLObject({
              path: [
              {workbench_variables: ''}
              ],
              update: {
                search: ''
              }
              })"
              />
          <v-btn
          class="ml-1"
          small
          @click="loadData(''), addLoadAll(`${prefix_wp_seletion}workpackages`)">
            Load all
          </v-btn>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
               class="ml-5"
               small
               v-on="on"
               v-bind="attrs"
               @click="switchWorkpackageType('')"
               :class="prefix_wp_seletion == ''?'grey':''"
               >
               <v-icon small>person</v-icon>
               </v-btn>
            </template>
            <span>{{$t('WorkBench.Editor.Sequence.TooltipOwn')}}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
               small
               v-on="on"
               v-bind="attrs"
               @click="switchWorkpackageType('b')"
               :class="prefix_wp_seletion == 'b'?'grey':''"
               >
               <v-icon small>work</v-icon>
               </v-btn>
            </template>
            <span>{{$t('WorkBench.Editor.Sequence.TooltipBusiness')}}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
               small
               v-on="on"
               v-bind="attrs"
               @click="switchWorkpackageType('c')"
               :class="prefix_wp_seletion == 'c'?'grey':''"
               >
               <v-icon small>people</v-icon>
               </v-btn>
            </template>
            <span>{{$t('WorkBench.Editor.Sequence.TooltipCommunity')}}</span>
          </v-tooltip>
          <v-btn
            class="ml-5"
            small
            :disabled="prefix_wp_seletion === 'c' || prefix_wp_seletion === 'b'"
            @click="createNewWorkpackage()"
            >
            create
          </v-btn>
        </StandardFlexBox>
        <StandardFlexBox
          width="100%"
          height="calc(100% - 28px"
          >
          <Workpackage
            class="ma-1 cursor-pointer"
            :zoom="1"
            :style="selected_id == workpackage.id?'border-style: solid; border-width: 2px !important; border-color: white !important;':''"
            v-for="workpackage in getWBObjectsFiltered({
              type: `${prefix_wp_seletion}workpackages`,
              search: {
                token: workbench_variables.search,
                name: workbench_variables.search,
                hashtag: workbench_variables.search,
              },
              })"
            :key="workpackage.id"
            :workpackage="workpackage"
            @click.native="$router.push({
                name: `${location}SequenceWaggonWorkPackageInfoBox`,
                params: {
                  info_box_template_type: workpackage.template_type?workpackage.template_type:'custom',
                  workpackage_id: workpackage.id,
                }
              }), selected_id = workpackage.id"
            >
            <template #workpackage>
              <StandardBadge
                v-if="workpackage.template_type && workpackage.template_type !== 'custom'"
                :zoom="1"
                :icon="workpackage.template_type === 'community'?'persons-two':'suitcase'"
                color="white"
                content_color="black"
                />
            </template>
          </Workpackage>
        </StandardFlexBox>
      </StandardFlexBox>
    </template>
  </WorkBenchSequenceWaggonWorkPackageAdd>
</template>
<script>
  import { WorkBenchSequenceMixin } from '@/mixins/WorkBenchSequence.mixin.js'
  export default {
    props: ['waggon_id', 'create', 'sequence_editor_variables', 'location'],
    mixins: [
      WorkBenchSequenceMixin,
    ],
    data: () => ({
      search: "",
      selected_id: -1
    }),
    beforeRouteLeave(to, from, next){
      this.updateWBLObject({
          path: [
            {workbench_variables: ''}
          ],
          update: {
            search: ''
          }
        });
        next();
    },
    created() {
      this.loadData(`&limit=8&offset=0`);
    },
    watch: {
      prefix() {
        this.loadData(`&limit=8&offset=0`);
      }
    },
    methods: {
      createNewWorkpackage(){
        this.createWBObject({
            url: [
              {sequences: this.$route.params.sequence_id},
              {swaggons: this.$route.params.waggon_id},
              {sworkpackages: ''},
              {showWithEntitiesNormalized: ''}
            ],
            wb_object: this.$store.getters['WorkBenchLocal/getWBLObject']({
              path: [
                {workpackage: ''},
              ]
            })
          }).then((created_id) => {
            this.$router.push({
              name: `${this.location}SequenceWaggonWorkPackageAddWorkPackageEditor`,
              params: { workpackage_id: created_id}
            })
          });
      },
      workbenchSearch(val){
        if (val && val !== '') {
          this.loadData(`&search=${val}`);
        }
        this.updateWBLObject({
            path: [
              {workbench_variables: ''}
            ],
            update: {
              search: val
            }
          })
      },
      loadData(url_suffix){
        return new Promise((resolve) => {
          this.updateWBLObject({
            path: [
              {workbench_variables: ''}
            ],
            update: {
              loading: true
            }
          });
          // if (['b', 'c'].includes(this.prefix) || this.isWBObjEmpty('sequences')) {
            this.requestWBObject({
              url: [
                {[`${this.prefix_wp_seletion}workpackages`]: ''},
                {showWithEntitiesNormalized: ''}
              ],
              url_suffix: url_suffix
            }).then(() => {
              this.updateWBLObject({
                path: [
                  {workbench_variables: ''}
                ],
                update: {
                  loading: false
                }
              });
              resolve();
            });
          // }
        });
      },
      switchWorkpackageType(type){
        this.prefix_wp_seletion = type;

        var workpackages = this.getWBObjectsFiltered({
          type: `${this.prefix_wp_seletion}workpackages`,
          search: {
            token: this.workbench_variables.search,
            name: this.workbench_variables.search,
            hashtag: this.workbench_variables.search,
          },
        })
        if (workpackages.length == 0) {
          this.loadData(`&limit=8&offset=0`);
        }
      }
    }
  }
</script>
<style>
  .class {

  }
</style>
